/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

/**
 * Contract Services Component Configuration
 * NOTE: for basic contracts with no extra services use the inclusiveServicesConfig instead
 */
export const inclusiveServicesConfig = [
  { name: 'Freihantelbereich mit Kurzhanteln bis 60kg' },
  { name: 'Kraftgerätepark von Lifefitness und Matrix' },
  { name: 'großer Cardiobereich' },
  { name: 'Functional-Area' },
  { name: 'Express-Zirkel' },
  { name: 'freies WLAN' },
];
